import {Divider, Grid} from '@mui/material';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import LinkImg from 'assets/img/link.svg';
import ShareSocialBtns from './ShareSocialBtns';
import Message from 'assets/img/messages-ios.svg';
import styles from 'assets/css/shareModal.module.css';
import {useEffect} from 'react';
import {useState} from 'react';

const MainView = (props) => {
  const {
    value,
    isCopied,
    shareContent,
    smsToOtherHandler,
    sendSMSHandler,
    setCopied,
    handleClose,
    phoneNumber,
  } = props;
  const [isAndroid, setIsAndroid] = useState(null);

  const postNavigateCommandToNative = () => {
    const url = value;
    const stringifyCommand = `navigateToShareUrl_${url}`;
    return window?.ReactNativeWebView?.postMessage(stringifyCommand);
  };

  const getUserOs = (event) => {
    const osData = JSON?.parse(event?.data);
    const osResult = osData?.platform === 'android' ? 'android' : 'ios';
    if (osResult === 'android') {
      setIsAndroid(true);
    }
    return osResult;
  };

  const getDeviceType = () => {
    window?.ReactNativeWebView?.postMessage('getversion');
    document.addEventListener('message', getUserOs);
    window.addEventListener('message', getUserOs);
  };

  useEffect(() => {
    getDeviceType();
    return () => {
      document.removeEventListener('message', getUserOs);
      window.removeEventListener('message', getUserOs);
    };
  }, [isAndroid]);

  return (
    <>
      <CloseIcon className={styles.closeIcon} onClick={() => handleClose()} />
      <Grid item className={styles.headerStyle} xs={12}>
        برای ارسال گزارش به صورت پیامک روی دکمه زیر کلیک کنید:
      </Grid>
      <Grid container xs={12} className={styles.sendWithSMS}>
        <Button
          className={styles.SMSBtn}
          onClick={() => sendSMSHandler(phoneNumber)}>
          <span className={styles.sendWithSMS}>
            <img src={Message} alt='' style={{paddingBottom: '3px'}} />
            <span className={styles.sendSMSText}>ارسال گزارش با SMS</span>
          </span>
        </Button>
      </Grid>
      <Divider variant='middle' className={styles.divider} />
      {/* -----------copy url container----------- */}
      <Grid item xs={12} className={styles.headerStyle2}>
        لینک جهت اشتراک با دیگران و یا در شبکه های اجتماعی:{' '}
      </Grid>
      <Grid item xs={12} className={styles.linkContainer}>
        <Grid item>
          <img src={LinkImg} alt='' className={styles.pinSVG} />
        </Grid>
        <Grid item className={styles.link} dir='rtl' xs={7.3} mt>
          <p id='shareLink' dir='ltr' className={styles.pTag}>
            {isAndroid ? (
              <a
                href={`${value}`}
                target='_blank'
                rel='noreferrer'
                style={{color: '#707070'}}>
                {value && value}
              </a>
            ) : (
              <div onClick={postNavigateCommandToNative}>{value && value}</div>
            )}
          </p>
        </Grid>
        <Grid item>
          <Button
            className={styles.copyBtn}
            sx={{
              color: isCopied && '#3CC0C3',
              border: isCopied && '1px solid #3CC0C3 !important',
            }}
            onClick={() => setCopied(value)}>
            {<span>{!isCopied ? 'کپی لینک ' : 'کپی شد'}</span>}
          </Button>
        </Grid>
      </Grid>
      {/*  ---------------social buttons-------------- */}
      <ShareSocialBtns
        shareContent={shareContent}
        smsToOtherHandler={smsToOtherHandler}
      />
    </>
  );
};

export default MainView;
